import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getRedeemCategory = async () => {
  return await get<ApiResponse<[]>>('/redeem/reward/category').then((res)=> {
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
};
